var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.45 5.875C36.266.815 41.573.791 41.573.791s.79 4.757-3.003 9.339c-4.05 4.892-8.652 4.092-8.652 4.092s-.865-3.848 2.53-8.347Zm-2.046 11.679c1.964 0 5.61-2.715 10.354-2.715 8.167 0 11.38 5.843 11.38 5.843s-6.284 3.23-6.284 11.069c0 8.842 7.828 11.89 7.828 11.89S48.21 59.126 40.819 59.126c-3.395 0-6.034-2.3-9.611-2.3-3.645 0-7.263 2.386-9.618 2.386-6.75 0-15.277-14.69-15.277-26.498 0-11.617 7.218-17.712 13.987-17.712 4.401 0 7.816 2.552 10.104 2.552Z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.003.001h60v60h-60z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5d8f58a6e620e6c8a346fbad4f33067f.svg";
export { ForwardRef as ReactComponent };